import React, {createRef, useState, useContext, Fragment} from 'react';
import moment from 'moment';
import __ from "lodash";
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../../controls/Material-Table-Components';
import {Checkbox, Icon, IconButton, Tooltip, useTheme} from "@material-ui/core";
import { v4 as uuidv4 } from 'uuid';

import SystemContext from "../../../../SystemContext";

import AirportLookup from "../../../Airports/components/AirportsLookup";
import {ColumnWidth, ValidatorColumn} from "../../../../blocks/ColumnHelper";
import TripLegsValidator from "../../validators/TripLegsValidator";
import { MaskedTime, FlightNumber, ComboSelect, MaskedText } from '../../../../controls';
import AircraftLookup from '../../../Aircraft/components/AircraftLookup';
import MovementsTooltip from './MovementsTooltip';
import tripTimesDialog from './TripTimesDialog';
import axios from 'axios';
import { getApiSitePrefix } from '../../../../functions/SiteDefaults';
import Duration from '../../../../controls/Duration';
import { WorldCheckIcon } from '../../../../icons';
import jetplanRouteDialog from './JetplanRouteDialog';

const apiSitePrefix = getApiSitePrefix();

const TimeIcon = (props) => {
  const {Dialog: TripTimesDialog, open: openTripTimesDialog} = tripTimesDialog();
  return (
    <Fragment>
      <IconButton
        id="setETD"
        onClick={()=> {
          const {rowData, onRowDataChange}=props;
          openTripTimesDialog(rowData, (changes)=> {
            onRowDataChange({...rowData, ...changes});
          })
        }}
      >
        <Icon>access_time</Icon>
      </IconButton>
      <TripTimesDialog classes={props.classes}/>
    </Fragment>
  )
}

const RouteIcon = (props) => {
  const {Dialog: JetplanRouteDialog, open: openJetplanRouteDialog} = jetplanRouteDialog();
  return (
    <Fragment>
      <IconButton
        id="setJetPlanRoute"
        onClick={()=> {
          const {rowData, onRowDataChange}=props;
          openJetplanRouteDialog(rowData, (changes)=> {
            onRowDataChange({...rowData, ...changes});
          })
        }}
      >
        <WorldCheckIcon />
      </IconButton>
      <JetplanRouteDialog classes={props.classes}/>
    </Fragment>
  )
}

const TripLegEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('Trip.AddSector', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }
  const props = {
    ..._props
  }
  const {classes, tripRecord} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null,
    preventDelete: props.preventDelete || false,
    hideTimes: props.hideTimes || false
  });

  const tripLegs = tripRecord.legs;
  const canChangeContractedTimes = props.canChangeContractedTimes === true;
debugger;
  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(TripLegsValidator, false);
    const  firstAirport = Array.isArray(tripLegs) && tripLegs.length > 0?tripLegs[0].originAirportCode:'';
    const  lastAirport = Array.isArray(tripLegs) && tripLegs.length > 0?tripLegs[tripLegs.length - 1].destinationAirportCode:'';
    const  lastAircraft = Array.isArray(tripLegs) && tripLegs.length > 0?tripLegs[tripLegs.length - 1].aircraftId:'';
    const  lastOffsetDay = Array.isArray(tripLegs) && tripLegs.length > 0?moment.utc(tripLegs[tripLegs.length - 1].contractedArrivalTimeUTC).add(2, 'hour').startOf('day').diff(moment.utc(tripRecord.tripDate).startOf('day'),'days'):0;

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(70,[5,2],undefined,undefined,undefined,undefined,false),
        title: "Origin",
        field: "originAirportCode",
        initialEditValue: lastAirport,
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(70,2,undefined,undefined,undefined,undefined,false),
        title: "Dest",
        field: "destinationAirportCode",
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            returnType="object"
            onChange={(returnObject)=>{
              if (returnObject.found) {
                const data = {
                  ...props.rowData,
                  destinationAirportCode: returnObject.data.airportCode,
                  alternateAirportCode: returnObject.data.alternateAirportCode||'',
                  alternateAirportIcaoCode: returnObject.data.alternateAirportIcaoCode||''
                }
                props.onRowDataChange(data);
              } else {
                props.onChange(returnObject.value);
              }
            }}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(70,2,undefined,undefined,undefined,undefined,false),
        title: "Alt",
        field: "alternateAirportCode",
        editable: ((cell, rowData, updatedData) => {
          return updatedData.transportType !== "TRUCK";
        }),
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            returnType="object"
            onChange={(returnObject)=>{
              if (returnObject.found) {
                const data = {
                  ...props.rowData,
                  alternateAirportCode: returnObject.data.airportCode,
                  alternateAirportIcaoCode: returnObject.data.icaoCode,
                }
                props.onRowDataChange(data);
              } else {
                props.onChange(returnObject.value);
              }
            }}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(100,2,undefined,undefined,undefined,undefined,false),
        title: "Transport Type",
        field: "transportType",
        initialEditValue: 'PRIMARY',
        render: (rowData) => (
          <ComboSelect
            id="transportType"
            group="TRANSPORT TYPES"
            subGroup=""
            fullWidth
            value={`${rowData.transportType}`}
            displayOnly={true}
          />
        ),
        editComponent: (props) => (
          <ComboSelect
            id="transportType"
            group="TRANSPORT TYPES"
            subGroup=""
            fullWidth
            value={`${props.value}`}
            onChange={(transportType) => {
              let legType = props.rowData.legType;
              let aircraftId = props.rowData.aircraftId;
              if (transportType === "PRIMARY") {
                if (legType === "NO FREESALE") {
                  legType = "";
                }
                if (aircraftId === "") {
                  aircraftId = lastAircraft;
                }
              } else {
                if (legType !== "NO FREESALE" && legType !== "FREESALE") {
                  legType = "";
                }
                aircraftId = "";
              }
              props.onRowDataChange({...props.rowData, transportType, legType, aircraftId});
            }}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,undefined,undefined,false),
        title: "Flight No",
        field: "flightNo",
        editable: ((cell, rowData, updatedData) => {
          return updatedData.transportType !== "TRUCK";
        }),
        editComponent: (props) => (
          <FlightNumber
            mask={"AX-999aa"}
            code={props.rowData.airlineCode}
            number={props.rowData.flightNo}
            inputProps={defaultEditProps}
            onChange={e => {
              const airlineCode = e.code;
              const flightNo = (e.number);
              let data = { ...props.rowData, airlineCode, flightNo };
              props.onRowDataChange(data);
            }}
          />
        ),
        render: (props) => (
          <div style={{ width: 92 }}>
            {props.airlineCode}&nbsp;{props.flightNo}
          </div>
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(60,[2,10],undefined,undefined,undefined,undefined,false),
        title: "Offset",
        field: "contractedDepartureTimeUTC",
        initialEditValue: lastOffsetDay,
        editable: (canChangeContractedTimes && state.canEdit)?"always":"onAdd",
        editComponent: (props) => {
          let offsetValue = lastOffsetDay;
          if (props?.rowData?.contractedDepartureTimeUTC) {
            offsetValue = moment.utc(props.rowData.contractedDepartureTimeUTC).startOf('day').diff(moment.utc(tripRecord.tripDate).startOf('day'),'days');
          }
          return (
            <MaskedText
              defaultValue={offsetValue}
              value={offsetValue}
              mask={"9"}
              inputProps={{ style:{ fontSize: "0.875rem", textAlign: "right" }}}
              onChange={(value)=> {
                let contractedDepartureTimeUTC = props.rowData.contractedDepartureTimeUTC;
                let contractedArrivalTimeUTC = props.rowData.contractedArrivalTimeUTC;
                if (!contractedArrivalTimeUTC) {
                  contractedArrivalTimeUTC = moment.utc(tripRecord.tripDate).startOf('day').toISOString();
                }
                if (!contractedDepartureTimeUTC) {
                  contractedDepartureTimeUTC = moment.utc(tripRecord.tripDate).startOf('day').toISOString();
                }
                const offsetValue = moment.utc(contractedDepartureTimeUTC).startOf('day').diff(moment.utc(tripRecord.tripDate).startOf('day'),'days');
                const daysDiff = value - offsetValue;
                if (daysDiff !== 0) {
                  let newScheduledDepartureTimeUTC = null;
                  let newScheduledArrivalTimeUTC = null;
                  newScheduledDepartureTimeUTC = moment.utc(contractedDepartureTimeUTC).add(daysDiff, 'day').toISOString();
                  newScheduledArrivalTimeUTC = moment.utc(contractedArrivalTimeUTC).add(daysDiff, 'day').toISOString();
                  props.onRowDataChange({
                    ...props.rowData,
                    contractedDepartureTimeUTC: newScheduledDepartureTimeUTC,
                    contractedArrivalTimeUTC: newScheduledArrivalTimeUTC,
                    scheduledDepartureTimeUTC: newScheduledDepartureTimeUTC,
                    scheduledArrivalTimeUTC: newScheduledArrivalTimeUTC
                  });
                }
              }}
              style={{ fontSize: "0.875rem", textAlign: "right" }}
            />
          )
        },
        render: (rowData) => {
          let offsetValue = 0;
          if (rowData?.contractedDepartureTimeUTC) {
            offsetValue = moment.utc(rowData.contractedDepartureTimeUTC).startOf('day').diff(moment.utc(tripRecord.tripDate).startOf('day'),'days');
          }
          return (
            <div style={{ width: 50, textAlign: "right" }}>
              {offsetValue}
            </div>
          )
        }
      },
      {
        ...baseColumn,
        ...ColumnWidth(65,2,undefined,undefined,undefined,undefined,false),
        title: "Departure UTC",
        field: "contractedDepartureTimeUTC",
        emptyValue: 0,
        defaultValue: 0,
        editable: (canChangeContractedTimes && state.canEdit)?"always":"onAdd",
        editComponent: (props) => (
          <MaskedTime
            source="timestamp"
            value={props.value}
            onChange={(value)=>{
              console.log('departuretime:',value);
              if (!value) return;
              if (typeof value !== 'string' || (value.length <= 5 && (value.indexOf(':') < 1 || value.split(':').length < 2))) return;
              if (value.length === 19) {
                value = value.substring(11,16);
              }
              value = value.replace(/\s/g, '0');
              const [hours,  minutes] =  value.split(':');
              if (isNaN(hours) || hours < 0 || hours > 23) return;
              if (isNaN(minutes) || minutes < 0 || hours > 59) return;

              let contractedDepartureTimeUTC = props.rowData.contractedDepartureTimeUTC;
              let contractedArrivalTimeUTC = props.rowData.contractedArrivalTimeUTC;
              let duration = moment.utc(contractedArrivalTimeUTC).diff(moment.utc(contractedDepartureTimeUTC), 'minutes');
              if (!contractedArrivalTimeUTC) {
                contractedArrivalTimeUTC = moment.utc(tripRecord.tripDate).startOf('day').add(lastOffsetDay, 'days').toISOString();
              }
              if (!contractedDepartureTimeUTC) {
                contractedDepartureTimeUTC = moment.utc(tripRecord.tripDate).add(lastOffsetDay, 'days').startOf('day').toISOString();
              }

              let newScheduledDepartureTimeUTC = contractedDepartureTimeUTC;
              let newScheduledArrivalTimeUTC = contractedArrivalTimeUTC;
              const contractedDepartureDate = moment.utc(contractedDepartureTimeUTC).startOf('day').format('YYYY-MM-DD');
              newScheduledDepartureTimeUTC = moment.utc(contractedDepartureDate).add(hours, 'hours').add(minutes, 'minutes').toISOString();

              if (duration > 0) {
                newScheduledArrivalTimeUTC = moment.utc(newScheduledDepartureTimeUTC).add(duration, 'minutes').toISOString();
              } else {
                const tempScheduledArrivalTimeUTC = moment.utc(contractedDepartureDate)
                  .add(moment.utc(contractedArrivalTimeUTC).get('hour'), 'hour')
                  .add(moment.utc(contractedArrivalTimeUTC).get('minute'), 'minute');
                if (moment.utc(newScheduledDepartureTimeUTC).isAfter(tempScheduledArrivalTimeUTC)){
                  newScheduledArrivalTimeUTC = moment.utc(tempScheduledArrivalTimeUTC).add(1, 'days').toISOString();
                } else {
                  newScheduledArrivalTimeUTC = tempScheduledArrivalTimeUTC.toISOString();
                }
              }
              console.log({
                scheduledDepartureTimeUTC: newScheduledDepartureTimeUTC,
                scheduledArrivalTimeUTC: newScheduledArrivalTimeUTC
              })
              props.onRowDataChange({
                ...props.rowData,
                contractedDepartureTimeUTC: newScheduledDepartureTimeUTC,
                contractedArrivalTimeUTC: newScheduledArrivalTimeUTC,
                scheduledDepartureTimeUTC: newScheduledDepartureTimeUTC,
                scheduledArrivalTimeUTC: newScheduledArrivalTimeUTC
              });
            }}
          />
        ),
        render: (props) => (
          <div style={{ width: 162 }}>
            {props.contractedDepartureTimeUTC?moment.utc(props.contractedDepartureTimeUTC).format("HH:mm"):""}
          </div>
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(65,2,undefined,undefined,undefined,undefined,false),
        title: "Arrival UTC",
        field: "contractedArrivalTimeUTC",
        emptyValue: 0,
        defaultValue: 0,
        editable: (canChangeContractedTimes && state.canEdit)?"always":"onAdd",
        editComponent: (props) => (
          <MaskedTime
            source="timestamp"
            value={props.value}
            onChange={(value)=>{
              if (!value) return;
              if (typeof value !== 'string' || value.indexOf(':') < 1 || value.split(':').length < 2) return;
              if (value.length === 19) {
                value = value.substring(11,16);
              }
              value = value.replace(/\s/g, '0');
              const [hours,  minutes] =  value.split(':');
              if (isNaN(hours) || hours < 0 || hours > 23) return;
              if (isNaN(minutes) || minutes < 0 || hours > 59) return;

              let contractedDepartureTimeUTC = props.rowData.contractedDepartureTimeUTC;
              if (!contractedDepartureTimeUTC) {
                contractedDepartureTimeUTC = moment.utc(tripRecord.tripDate).startOf('day').toISOString();
              }
              let newScheduledArrivalTimeUTC;
              const tempScheduledArrivalTimeUTC = moment.utc(contractedDepartureTimeUTC).startOf('day')
                                                        .add(hours, 'hour')
                                                        .add(minutes, 'minute');
              if (moment.utc(contractedDepartureTimeUTC).isAfter(tempScheduledArrivalTimeUTC)){
                newScheduledArrivalTimeUTC = moment.utc(tempScheduledArrivalTimeUTC).add(1, 'days').toISOString();
              } else {
                newScheduledArrivalTimeUTC = tempScheduledArrivalTimeUTC.toISOString();
              }
              props.onRowDataChange({
                ...props.rowData,
                contractedArrivalTimeUTC: newScheduledArrivalTimeUTC,
                scheduledArrivalTimeUTC: newScheduledArrivalTimeUTC
              });
            }}
          />
        ),
        render: (props) => (
          <div style={{ width: 162 }}>
            {props.contractedArrivalTimeUTC?moment.utc(props.contractedArrivalTimeUTC).format("HH:mm"):""}
          </div>
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(70, 2, undefined,undefined,undefined,undefined,false),
        title: "Duration",
        field: "contractedArrivalTimeUTC",
        render: (rowData) => {
          const departureMoment = moment.utc(rowData.contractedDepartureTimeUTC);
          const arrivalMoment = moment.utc(rowData.contractedArrivalTimeUTC);
          const diff = arrivalMoment.diff(departureMoment, 'minutes');
          const hours = parseInt(diff/60);
          const minutes = diff % 60;

          if (hours) {
            return (
              <div>{hours}h {minutes}m</div>
            )
          }
          return (
            <div>{minutes}m</div>
            );
        },
        editComponent: props => {
          const departureMoment = moment.utc(props.rowData.contractedDepartureTimeUTC);
          const arrivalMoment = moment.utc(props.rowData.contractedArrivalTimeUTC);
          const diff = arrivalMoment.diff(departureMoment, 'minutes');
          return (
            <Duration
              value={diff}
              onChange={(durationObject)=>{
                if (!durationObject) return;
                const {hours, minutes, duration} = durationObject;

                let contractedDepartureTimeUTC = props.rowData.contractedDepartureTimeUTC;
                if (!contractedDepartureTimeUTC) {
                  contractedDepartureTimeUTC = moment.utc(tripRecord.tripDate).toISOString();
                }
                let newScheduledArrivalTimeUTC;
                const tempScheduledArrivalTimeUTC = moment.utc(contractedDepartureTimeUTC)
                                                          .add(hours, 'hour')
                                                          .add(minutes, 'minute');
                newScheduledArrivalTimeUTC = tempScheduledArrivalTimeUTC.toISOString();
                props.onRowDataChange({
                  ...props.rowData,
                  contractedArrivalTimeUTC: newScheduledArrivalTimeUTC,
                  scheduledArrivalTimeUTC: newScheduledArrivalTimeUTC
                });
              }}
            />
          )
        }
      },
      {
        ...baseColumn,
        ...state.hideTimes ? {title: "", ...ColumnWidth(68, 2, undefined,undefined,undefined,undefined,false)} : {
          ...ColumnWidth(50, 2, undefined,undefined,undefined,undefined,false),
          title: "Times",
          field: "scheduledDepartureTimeUTC",
          render: (rowData) => {
            if (rowData.aircraftMovementUuid) {
              return (
                <MovementsTooltip aircraftMovementUuid={rowData.aircraftMovementUuid} tripLeg={rowData}>
                  <Icon>access_time_filled</Icon>
                </MovementsTooltip>
              )
            } else if (rowData.estimatedDepartureTimeUTC || rowData.estimatedArrivalTimeUTC || rowData.scheduledDepartureTimeUTC !== rowData.contractedDepartureTimeUTC || rowData.scheduledArrivalTimeUTC != rowData.contractedArrivalTimeUTC) {
              return (
                <MovementsTooltip aircraftMovementUuid={rowData.aircraftMovementUuid} tripLeg={rowData}>
                  <Icon>access_time</Icon>
                </MovementsTooltip>
              )
            } else return "";
          },
          editComponent: (props) => (
            <TimeIcon
              id="setETD"
              rowData={props.rowData}
              onRowDataChange={props.onRowDataChange}
              classes={classes}
            />
          ),
        },
      },
      // {
      //   title: " ",
      //   field: "",
      //   render: ()=>(<>&nbsp;</>),
      //   editable: "never",
      //   editCellStyle: {minWidth: 80},
      // },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,undefined,undefined,false),
        title: "Leg Type",
        field: "legType",
        initialEditValue: 'FULL CHARTER',
        render: (rowData) => (
          <ComboSelect
            id="legType"
            group="TRIP LEG TYPES"
            subGroup={rowData.transportType}
            fullWidth
            value={rowData.legType}
            displayOnly={true}
          />
        ),
        editComponent: (props) => (
          <ComboSelect
            id="legType"
            group="TRIP LEG TYPES"
            subGroup={props.rowData.transportType}
            fullWidth
            value={props.rowData.legType}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,undefined,undefined,false),
        title: "Aircraft",
        field: "aircraftId",
        initialEditValue: lastAircraft,
        editable: ((cell, rowData, updatedData) => {
          return updatedData.transportType === "PRIMARY";
        }),
        editComponent: (props) => (
          <AircraftLookup
            id="aircraft"
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(65,2,undefined,undefined,undefined,undefined,false),
        title: "Tech Stop",
        field: "techStop",
        align: "center",
        editable: props.canEdit ? "always" : "never",
        emptyValue: false,
        initialEditValue: false,
        type: "boolean",
        render: rowData =>
          <Tooltip title={
            `${rowData.originAirportCode === firstAirport || firstAirport === '' 
              ? "Tech Stop cannot be set for the first sector"
              : `${(rowData.techStop === 1 || rowData.techStop === true) 
                  ? `Tech Stop at ${rowData.originAirportCode}. Loading not allowed for this airport.`
                  : `Set Tech Stop at ${rowData.originAirportCode}. Loading will not be allowed for this airport.`
                }`
            }`
          }>
            <Checkbox
              style={{padding: 0}}
              disabled={rowData.originAirportCode === firstAirport || firstAirport === ''}
              checked={(rowData.techStop === 1 || rowData.techStop === true) ?? true}
              value="true"
            />
          </Tooltip>,
        editComponent: (props) =>
          <div style={{width: '100%',textAlign: 'center'}}>
            <Tooltip title={`${(props.rowData.techStop === 1 || props.rowData.techStop === true) ? "" : "Set "}Tech Stop at ${props.rowData.originAirportCode}`}>
              <Checkbox
                style={{padding: 0}}
                disabled={props.rowData.originAirportCode === firstAirport || firstAirport === ''}
                checked={(props.rowData.techStop === 1 || props.rowData.techStop === true) ?? true}
                value="true"
                onChange={ (evt,checked) => {
                  props.onRowDataChange({
                    ...props.rowData,
                    techStop: checked || false,
                    allowLoading: checked ? false : props.rowData.allowLoading,
                  });
                }}
              />
            </Tooltip>
          </div>
      },
      {
        ...baseColumn,
        ...ColumnWidth(65,2,undefined,undefined,undefined,undefined,false),
        title: "Loading Allowed",
        field: "allowLoading",
        align: "center",
        editable: props.canEdit ? "always" : "never",
        emptyValue: false,
        initialEditValue: false,
        type: "boolean",
        render: rowData =>
          <Tooltip title={ `${(rowData.allowLoading === 1 || rowData.allowLoading === true) ? "Loading allowed" :"Loading not allowed"} at ${rowData.originAirportCode}` }>
            <Checkbox
              style={{padding: 0}}
              disabled={(rowData.techStop === 1 || rowData.techStop === true) ?? true}
              checked={(rowData.allowLoading === 1 || rowData.allowLoading === true) ?? true}
              value="true"
              onChange={ checked => {props.onChange(checked)} }
            />
          </Tooltip>,
        editComponent: (props) =>
          <div style={{width: '100%',textAlign: 'center'}}>
            <Tooltip title={`Allow Loading at ${props.rowData.originAirportCode}`}>
              <Checkbox
                style={{padding: 0}}
                disabled={(props.rowData.techStop === 1 || props.rowData.techStop === true) ?? true}
                checked={(props.rowData.allowLoading === 1 || props.rowData.allowLoading === true) ?? true}
                value="true"
                onChange={ (evt,checked) => {props.onChange(checked || false)} }
              />
            </Tooltip>
          </div>
      },
      {
        ...baseColumn,
        ...ColumnWidth(65,2,undefined,undefined,undefined,undefined,false),
        title: "Through Allowed",
        field: "allowThroughCargo",
        align: "center",
        editable: props.canEdit ? "always" : "never",
        emptyValue: false,
        initialEditValue: false,
        type: "boolean",
        render: rowData =>
          <Tooltip title={ `${(rowData.allowThroughCargo === 1 || rowData.allowThroughCargo === true) ? "Cargo allowed to continue through" :"Cargo must be unloaded at"} ${rowData.destinationAirportCode}` }>
            <Checkbox
              style={{padding: 0}}
              checked={(rowData.allowThroughCargo === 1 || rowData.allowThroughCargo === true) ?? true}
              value="true"
            />
          </Tooltip>,
        editComponent: (props) =>
          <div style={{width: '100%',textAlign: 'center'}}>
            <Tooltip title={`Allow cargo to continue through ${props.rowData.destinationAirportCode}`}>
              <Checkbox
                style={{padding: 0}}
                checked={(props.rowData.allowThroughCargo === 1 || props.rowData.allowThroughCargo === true) ?? true}
                value="true"
                onChange={ (evt,checked) => {props.onChange(checked || false)} }
              />
            </Tooltip>
          </div>
      },
      {
        ...baseColumn,
        ...ColumnWidth(50, 2, undefined,undefined,undefined,undefined,false),
        title: "JetPlan Code",
        field: "jetPlanRoute",
        align: "center",
        render: (rowData) => {
          if (rowData.jetPlanRoute) {
            return (
              <Tooltip title={`Track Code: ${rowData.jetPlanRoute}`}>
                <span><WorldCheckIcon /></span>
              </Tooltip>
            )
          } else return "";
        },
        editComponent: (props) => (
          <div style={{width: '100%', textAlign: 'center', color: props.rowData.jetPlanRoute ? "primary" : "#999999"}}>
          <RouteIcon
            id="setJetPlanRoute"
            rowData={props.rowData}
            onRowDataChange={props.onRowDataChange}
            classes={classes}
          />
          </div>
        ),
      },
    ];
  };

  const bodyRef = createRef();

  const checkIfRouteChanged = async (newData, oldData) => {
    let showMessage = false;
    if (newData.originAirportCode !== oldData.originAirportCode) {
      showMessage = true;
    }
    if (newData.destinationAirportCode !== oldData.destinationAirportCode) {
      showMessage = true;
    }
    if (showMessage)
      SystemData.alert('Services Reset', 'Due to the route changing, the services have been reset, please check services and allotments and update as needed!');
  }

  const checkCurfew = (tripLeg, resolve, reject) => {
    const {scheduledDepartureTimeUTC, scheduledArrivalTimeUTC, estimatedDepartureTimeUTC, estimatedArrivalTimeUTC, originAirportCode, destinationAirportCode} = tripLeg;

    let dateTime = estimatedDepartureTimeUTC||scheduledDepartureTimeUTC;
    axios.get(
      `${apiSitePrefix}/airports/checkCurfewAndNotams/${originAirportCode}/OUT/${dateTime}`
    ).then(curfewCheck => {
      if (curfewCheck.data) {
        SystemData.confirm(
          `Curfew At Origin`,
          `A Curfew is in operation at the Origin are you sure you wish to continue?'`,
          [
            {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
            {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
          ],
          (response) => {
            if (response) {
              resolve();
            } else {
              reject();
            }
          }
        );
      } else {
        dateTime = estimatedArrivalTimeUTC||scheduledArrivalTimeUTC;
        axios.get(
          `${apiSitePrefix}/airports/checkCurfewAndNotams/${destinationAirportCode}/IN/${dateTime}`
        ).then(curfewCheck => {
          if (curfewCheck.data && Array.isArray(curfewCheck.data) && curfewCheck.data.length > 0) {
            let title = `Curfew At Destination`;
            let message = `A Curfew is in operation at the Destination. Are you sure you wish to continue?`;
            curfewCheck.data.forEach(curfew => {
              if (__.has(curfew, "notamCode") && curfew.notamCode === "BLACKLIST") {
                title = `Destination Country Blacklisted`;
                message = `Destination airport is within a blacklisted country (${curfew.countryCode}). Are you sure you wish to continue?`;
              }
            });
            SystemData.confirm(
              title,
              message,
              [
                {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}},
                {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
              ],
              (response) => {
                if (response) {
                  resolve();
                } else {
                  reject();
                }
              }
            );
          } else {
            resolve();
          }
        })
      }
    });

  }

  return (isAuthenticated &&
        <div className={classes.TripLegEditor}>
          <MaterialTable
            tableRef={tableRef}
            data={tripLegs}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              actionsColumnWidth: state.preventDelete ? 55 : undefined,
              onEditModeChanged: (editMode)=> {
                if (props.changeButtonState) {
                  const changes = {
                    save: {disabled: false, hidden: false},
                    addSector: {disabled: false, hidden: false}
                  }
                  if (editMode) {
                    changes['save'] = {disabled: true, hidden: false}
                    changes['addSector'] = {disabled: true, hidden: false}
                  }
                  props.changeButtonState(changes);
                }
              },
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={300}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Scheduled Trip Sectors"
            columns={getColumns({...props, canEdit: state.canEdit})}
            actions={[
            ]}
            editable={{
              isEditable: (props) => {
                return state.canEdit;
              },
              isDeletable: (props) => {
                return state.canEdit && !state.preventDelete && (props.aircraftMovementUuid === null || props.aircraftMovementUuid === undefined);
              },
              onRowAdd: state.canEdit
                  ? (newData) => new Promise((resolve, reject) => {
                    checkCurfew(newData,
                      () => {
                        if (Array.isArray(tripLegs)) {
                          tripLegs.push({...newData, tripLegUuid: uuidv4()});
                          props.onChange({record: {...props.tripRecord, legs: tripLegs}, oldRecord: props.tripRecord, resolve, reject});
                        } else {
                          reject();
                        }
                      },
                      () => {
                        reject();
                      }
                    )
                   })
                  : undefined,
              onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    checkIfRouteChanged(newData, oldData).then(()=> {
                      checkCurfew(newData,
                      () => {
                        const tripLegIdx = __.findIndex(tripLegs, {tripLegUuid: oldData.tripLegUuid});
                        if (tripLegIdx >= 0) {
                          tripLegs[tripLegIdx] = newData;
                          props.onChange({record: {...props.tripRecord, legs: tripLegs}, oldRecord: props.tripRecord, resolve, reject});
                        } else {
                          reject();
                        }
                      },
                      () => {
                        reject();
                      }
                    )
                  })
                }),
              onRowDelete: state.preventDelete? undefined : (oldData) =>
                  new Promise((resolve, reject) => {
                    const tripLegIdx = __.findIndex(tripLegs, {tripLegUuid: oldData.tripLegUuid});
                    if (tripLegIdx >= 0) {
                      tripLegs.splice(tripLegIdx, 1);
                      props.onChange({record: {...props.tripRecord, legs: tripLegs}, oldRecord: props.tripRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  }),
            }}
        />
      </div>
  );
}

export default TripLegEditor;
